import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetAddtional } from "./useGetAddtional"
import { AddtionalEntity } from "../../Objects/Addtional/AddtionalEntity"
import { useTranslation } from "react-i18next"

export const useSaveAddtional = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetAddtional } = useGetAddtional()

  const handleSaveAddtional = async (addtional: AddtionalEntity, onSuccess: any, imageFile?: any | null) => {
    try {
      enableLoad()

      var response = null

      if (addtional.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.ADDTIONAL.PUT}/${addtional.id}`, addtional.toJSON(imageFile))
      } else {
        response = await PostFormRequest(API_ROUTES.ADDTIONAL.CREATE, addtional.toJSON(imageFile))
      }

      if (response.success) {
        await handleGetAddtional(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSaveAddtional,
  }
}
